module.exports = __webpack_public_path__ + "static/media/img-fin-compra.70eb90e1.png";